<template>
	<div id="uploadcobmit">
		<div id="cobmitTrue">
			<img src="../../assets/bohui.png" /><br>
			<span class="cobmitwz">等待平台审核!</span>
			<p>提交成功等待平台审核...</p>
		</div>
	</div>
</template>

<script>
import Select from '@/components/Select'
export default {
  data() {
	return {
	  active: 0,
	  TimeShow: false,
	  PlaceShow: false,
	  radio: ''
	};
  },
  components: {
	Select
  },
};
</script>

<style>
	#uploadcobmit{
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		font-size: 30px;
		/* padding-top: 60px;
		margin-left: 400px; */
		width: 100%;
		height: 1024px;
		background-color: rgba(239, 239, 239);
	}
	#top {
	  width: 100%;
	  height: 70px;
	  line-height: 70px;
	  vertical-align: middle;
	  background-color: rgba(245, 245, 245);
	}
	.centerwz{
		text-align: center;
	}
	#cobmitTrue{
		width:100%;
		height: 300px;
		background-color: #FFFFFF;
	}
	img{
		width: 10%;
	}
	#cobmitTrue img{
		margin-left: 350px;
		margin-top: 50px;
	}
	.cobmitwz{
		font-size: 18px;
		font-family: "宋体";
		margin-left: 350px;
	}
	#cobmitTrue p{
		font-size: 12px;
		font-family: "宋体";
		margin-left: 250px;
	}
</style>
